module.exports = __webpack_public_path__ + "img/maneken_back_merures.fbbce8a5.png";